export default "__VITE_ASSET__bzzg0pIN__"